import BaseComponent from '../../../base/base_component';
import {USER_EVENTS} from '../../../events/events';

let closeButtonHtml = require('../view/close-button.html');

export default class CloseButtonNavbarPart extends BaseComponent {
    static CLASS = 'CloseButtonNavbarPart';

    init(params) {
        super.init(params);
        this._onCloseCallback = params.onCloseCallback;
        this.setInnerHtml(closeButtonHtml);
        this.onChildElementEvent('.game-panel-close-btn', USER_EVENTS.ON_CLICK, this._onClose.bind(this));
    }

    _onClose() {
        this._onCloseCallback();
    }
}